import { Panel } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import React, { Component } from 'react';
import { DataDroit } from '../../data/DataDroit.jsx';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxTypeMandat } from '../ComboBox/ComboBoxTypeMandat.jsx';
import { EUIComboBox } from '../EUI/EUIComboBox.jsx';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
***************************************************************
 PROPS:
    ! Toujours en création !

    estMontre
    listDroit: [],
    listTypeMandat: [],
    listTypeMandatDroit: [],

    onAnnuleFiche : méthode
    onEnregistrementFiche : méthode

***************************************************************
*/

export class FicheDroit extends Component {
    objetState = {
        optionsFonctionnalite: [],
        optionsAction: [],

        idTypeMandatSelected: 0,
        domaineSelected: '',
        fonctionnaliteSelected: '',
        actionSelected: '',

        enCoursDeTraitement: false,
        messageEnCoursTraitement: '',

        hideMessageBarError: true,
        errorMessage: '',
        hideMessageBarWarning: true,
        warningMessage: ''
    };

    constructor(props) {
        super(props);

        this.state = this.objetState;
    }


    _creationContent() {
        const optionsTypeMandat = this.props.listTypeMandat.map(item => ({ key: item.idTypeMandat, text: item.typeMandat }));

        const optionsDomaine = this.props.listDroit.reduce((acc, item) => {
            if (!acc.some(opt => opt.key === item.domaine))
                acc.push({ key: item.domaine, text: item.domaine })
            return acc;
        }, []);

        const { optionsFonctionnalite, optionsAction } = this.state;

        return (
            <Panel
                isOpen={this.props.estMontre}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                headerText="Ajout de droit"
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                <ComboBoxTypeMandat
                    inclureAdministrateur
                    inclureCallCenter
                    inclureCommercialisateur
                    inclureControleDeGestionNational
                    inclureEbook
                    inclureMaisonIndividuelle
                    inclureModuleExterne
                    inclurePrimPromo
                    inclureWebServices
                    onChange={(event, option) => this._onChangeTypeMandat(option)}
                    required
                    selectedKey={this.state.idTypeMandatSelected}
                />

                <EUIComboBox
                    label="Domaine"
                    onChange={(event, option) => this._onChangeDomaine(option)}
                    options={optionsDomaine}
                    placeholder="Domaine"
                    required
                    selectedKey={this.state.domaineSelected}
                />

                <EUIComboBox
                    disabled={!this.state.domaineSelected}
                    label="Fonctionnalité"
                    onChange={(event, option) => this._onChangeFonctionnalite(option)}
                    options={optionsFonctionnalite}
                    placeholder="Fonctionnalité"
                    required
                    selectedKey={this.state.fonctionnaliteSelected}
                />

                <EUIComboBox
                    label="Action"
                    disabled={!this.state.fonctionnaliteSelected}
                    onChange={(event, option) => this._onChangeAction(option)}
                    options={optionsAction}
                    placeholder="Action"
                    required
                    selectedKey={this.state.actionSelected}
                />
            </Panel>
        );
    }

    _onInit() {
        this.setState(this.objetState);
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onChangeDomaine = (item) => {
        if (!item) return;

        const optionsFonctionnalite = this.props.listDroit.reduce((acc, droit) => {
            const memeDomaine = droit.domaine === item.key;
            const dejaAjoute = acc.some(opt => opt.key === droit.fonctionnalite);
            if (memeDomaine && !dejaAjoute)
                acc.push({ key: droit.fonctionnalite, text: droit.fonctionnalite })
            return acc;
        }, []);

        this.setState({
            domaineSelected: item.key,
            fonctionnaliteSelected: '',
            optionsFonctionnalite
        });
    }

    _onChangeFonctionnalite = (item) => {
        if (!item) return;

        const optionsAction = this.props.listDroit.reduce((acc, droit) => {
            const memeDomaineEtFct = droit.domaine === this.state.domaineSelected && droit.fonctionnalite === item.key;
            const dejaAjoute = acc.some(opt => opt.key === droit.action);
            if (memeDomaineEtFct && !dejaAjoute)
                acc.push({ key: droit.action, text: droit.action })
            return acc;
        }, []);

        this.setState({
            fonctionnaliteSelected: item.key,
            actionSelected: '',
            optionsAction
        });
    }

    _onChangeAction = (item) => {
        if (!item) return;

        this.setState({ actionSelected: item.key });
    }

    _onChangeTypeMandat = (item) => {
        if (!item) return;

        this.setState({ idTypeMandatSelected: item.key });
    }

    _onOpen = () => {
        this._onInit();
    }

    _onRenderFooterContent = () => {
        const disabledButton = this._validationFormulaire()

        return (
            <div>
                <PrimaryButton onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={disabledButton}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    _validationFormulaire = () => {
        const { idTypeMandatSelected, domaineSelected, fonctionnaliteSelected, actionSelected } = this.state;
        return (!idTypeMandatSelected || !domaineSelected || !fonctionnaliteSelected || !actionSelected);
    }

    _onEnregistrement = () => {
        this._afficheLoader('Enregistrement du droit en cours');
        const { idTypeMandatSelected, domaineSelected, fonctionnaliteSelected, actionSelected } = this.state;

        const droit = this.props.listDroit.filter((droit) => droit.domaine === domaineSelected && droit.fonctionnalite === fonctionnaliteSelected && droit.action === actionSelected)
        if (!droit || droit.length !== 1) {
            this._cacheLoader();
            this._afficheMessageErreur("setmessageerror:le droit n'a pas été retrouvé")
            return;
        }

        const idDroit = droit[0].idDroit;
        const idTypeMandat = idTypeMandatSelected;

        // Verifie que le droit n'est pas déjà attribué
        const exist = this.props.listTypeMandatDroit.some(item => item.idDroit === idDroit && item.idTypeMandat == idTypeMandat);
        if (exist) {
            this._cacheLoader();
            this._afficheMessageErreur("le droit à attribuer existe déjà");
            return;
        }

        DataDroit._enregistrementTypeMandatDroit({ idDroit, idTypeMandat })
            .then(responseFetch => {
                const statePropertiesStatutsPage = Immocom.notifieStatusHttpImmocom(responseFetch, this);
                const pasEnErreur = statePropertiesStatutsPage.hideMessageBarWarning && statePropertiesStatutsPage.hideMessageBarError;
                this.setState({
                    idTypeMandatselected: 0,
                    domaineSelected: '',
                    fonctionnaliteSelected: '',
                    actionSelected: '',
                    ...statePropertiesStatutsPage
                });
                this.props.onEnregistrementFiche();
            })
            .catch(ex => console.log(ex))
            .finally(() => this._cacheLoader());
    }

    render() {
        return this._creationContent();
    }

    _afficheLoader = (message) => this.setState({
        enCoursDeTraitement: true,
        messageEnCoursTraitement: message
    });

    _cacheLoader = () => this.setState({
        enCoursDeTraitement: false,
        messageEnCoursTraitement: ''
    });

    _afficheMessageErreur = (message) => this.setState({
        hideMessageBarError: false,
        errorMessage: message
    });

    _cacheMessageErreur = () => this.setState({
        hideMessageBarError: true,
        errorMessage: ''
    });

    _afficheMessageAvertissement = (message) => this.setState({
        hideMessageBarError: false,
        errorMessage: message
    });

    _cacheMessageAvertissement = () => this.setState({
        hideMessageBarError: true,
        errorMessage: ''
    });

}